import PostCaption from './PostCaption';

customElements.define('post-caption', PostCaption);
